/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Model_ProductTypeGet } from '../models/Model_ProductTypeGet';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ProductTypeService {
    /**
     * @returns Model_ProductTypeGet Success
     * @throws ApiError
     */
    public static getApiV1ProductTypes(): CancelablePromise<Array<Model_ProductTypeGet>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/productTypes',
        });
    }
}
